<template>
  <div style="overflow-y: auto">
    <div v-if="$store.state.addRentalVehicleFormActive == false">
      <v-card class="elevation-0">
        <!-- <v-tabs
          v-if="checkTag('property_rentals')"
          v-model="tab"
          background-color="light-blue darken-2"
          dark
          align-with-title
          center-active
          height="50px"
        >
          <v-tab v-if="checkTag('property_rentals')" href="#property-rental-history">
            {{ $t("router_titles.property_rentals_history") }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            :key="'property-rental-history'"
            :value="'property-rental-history'"
          > -->
            <property-rental-history :property="property"></property-rental-history>
          <!-- </v-tab-item>
        </v-tabs-items> -->
      </v-card>
    </div>
    <div v-else>
      <add-property-rental-history />
    </div>
  </div>
</template>

<script>
import PropertyRentalHistory from "@/components/PropertyRentals/PropertyRentalHistoryTab";
import AddPropertyRentalsHistory from "@/views/PropertyRentals/Booking";

export default {
  components: {
    "property-rental-history": PropertyRentalHistory,
    "add-property-rental-history": AddPropertyRentalsHistory,
  },
  props: {
    property: [Object],
  },
  name: "Property-Rental-Tabs",
  data() {
    return {
      tab: null,
      showBookingDialog: false,
    };
  },
};
</script>

<style scoped></style>
